import * as React from "react";
import type { SVGProps } from "react";
const SvgChevronSmallDownGray = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 32 32" {...props}>
    <path
      fill="#b3aca9"
      d="M8 12a1 1 0 0 1 1.828-.561c2.218 3.273 4.293 5.773 6.172 7.436 1.88-1.665 3.956-4.165 6.172-7.436a1 1 0 1 1 1.656 1.122c-2.45 3.615-4.666 6.248-6.777 8.05-.605.52-1.5.52-2.104-.001-2.11-1.801-4.326-4.434-6.776-8.05a.997.997 0 0 1-.164-.44L8 12Z"
    />
  </svg>
);
export default SvgChevronSmallDownGray;
